export const authFormLabelProps = {
	fontSize: 'sm',
	fontWeight: '600',
	color: 'gray.700',
	mb: 1.5,
};

export const authFormInputProps = {
	size: 'lg',
	borderRadius: 'xl',
	bg: 'gray.50',
	border: '1px solid',
	borderColor: 'gray.200',
	_placeholder: { color: 'gray.400' },
	_hover: { borderColor: 'gray.300', bg: 'white' },
	_focusVisible: {
		borderColor: 'teal.400',
		bg: 'white',
		boxShadow: '0 0 0 3px rgba(45, 212, 191, 0.2)',
	},
};

export const authFormPrimaryButtonProps = {
	size: 'lg',
	w: '100%',
	borderRadius: 'xl',
	colorScheme: 'teal',
	fontWeight: '700',
	bg: 'teal.500',
	_hover: { bg: 'teal.600', transform: 'translateY(-1px)', boxShadow: 'md' },
	_active: { transform: 'translateY(0)' },
	transition: 'all 0.2s',
};

export const authFormLinkProps = {
	color: 'teal.600',
	fontWeight: '600',
	_hover: { color: 'teal.700', textDecoration: 'underline' },
};

export const authFormMutedTextProps = {
	fontSize: 'sm',
	color: 'gray.600',
	textAlign: 'center',
};

export const authFormShellProps = {
	w: '100%',
	mx: 'auto',
};
